import React from 'react';
import './Testimonials.scss';
import img1 from '../images/img1.jpeg'
import img2 from '../images/img2.jpeg'
import img3 from '../images/img3.jpeg'
import img4 from '../images/img4.jpeg'
import img5 from '../images/img5.jpeg'
import img6 from '../images/img6.jpeg'

const testimonials = [
  {
    imgSrc: img1,
    title: 'Debate Sessions',
    text: 'Debate, Discuss, Discover: Unleash your opinions and engage with our community!',
  },
  {
    imgSrc: img2,
    title: 'Daily Sessions',
    text: 'Daily Discussions, Lasting Insights: Be part of our daily sessions!',
  },
  {
    imgSrc: img3,
    title: 'Group Discussions',
    text: 'Connect, Collaborate, Discuss: Join our group discussions!',
  },
  {
    imgSrc: img4,
    title: 'Skit Sessions',
    text: 'Drama, Laughter, Learning: Be part of our skit sessions.',
  },
  {
    imgSrc: img5,
    title: 'Peer Meetups',
    text: 'Connect, Share, Grow: Join our peer meetups!',
  },
  {
    imgSrc: img6,
    title: 'Study Sessions',
    text: 'Learn Together, Grow Together: Join our study sessions!',
  },
];

const Testimonials = () => {
  return (
    <div className="testimonials-section">
      <div className="testimonials-container">
        {testimonials.map((testimonial, index) => (
          <div className="testimonial-card" key={index}>
            <img src={testimonial.imgSrc} alt={testimonial.title} className="testimonial-image" />
            <h3>{testimonial.title}</h3>
            <p>{testimonial.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Testimonials;
